import {
  SET_CONTACT_LIST,
  SET_SIDEBAR_VAL,
  SET_READY_BUTTON,
  SET_SHOWING_STATUS_VOICE,
  SET_SHOWING_STATUS,
  SET_SHOWING_STATUS_CLASS,
  SET_SELECTED_MENU,
  SET_SELECTED_EXTERNAL_CHAT_TYPE,
  SET_ARRIVAL_MESSAGE,
  SET_EXTERNAL_CHAT_DATA,
  SET_INTERNAL_CHAT_DATA,
  SET_CHAT_SESSION_ID,
  SET_CUSTOMER_TYPING_ID,
  SET_VOICE_AVAILABLE,
  SET_VOICE_PLAT_FORM,
  SET_WEB_RTC,
  SET_CLI,
  SET_CONTACT_LIST_LOADER,
  MISSED_CHATS,
  SET_DROPDOWN_AGENT_LIST,
} from "../../Redux/Actions/type";

const initialState1 = {
  contactList: [],
  missedChats: [],
  sidebarVal: "Dashboard",
  readyButton: false,
  showingStatus: "Connected",
  showingStatusVoice: "Connected",
  showingStatusClass: "showStatusConnected",
  selectedExternalChatType: "",
  arrivalMessage: null,
  selectedMenu: "ReportMenu",
  internalChatData: [],
  externalChatData: [],
  chatSessionId: "",
  DropDownAgentList: [],
  customerTypingId: "",
  contactlistLoader: true,
  voiceAvailable: false,
  voicePlatForm: "",
  CurrentTab: "customerDetails",
  webRTC: false,
  chatBotLink: {},
  cli: {},
  showEndChatBackDropSpinner: false,
};

export const contactListReducer = (state = initialState1, action) => {
  switch (action.type) {
    case "SET_SHOW_END_CHAT_BACK_DROP_SPINNER":
      return {
        ...state,
        showEndChatBackDropSpinner: action.val,
      };
    case SET_CLI:
      return {
        ...state,
        cli: action.val,
      };
    case SET_VOICE_PLAT_FORM:
      return {
        ...state,
        voicePlatForm: action.val,
      };
    case "SET_CURRENT_TAB": {
      return {
        ...state,
        CurrentTab: action.val,
      };
    }
    case SET_WEB_RTC:
      return {
        ...state,
        webRTC: action.val,
      };
    case "SET_CHAT_BOT_LINK": {
      return {
        ...state,
        chatBotLink: action.val,
      };
    }
    case SET_ARRIVAL_MESSAGE:
      return {
        ...state,
        arrivalMessage: action.val,
      };
    case SET_VOICE_AVAILABLE:
      return {
        ...state,
        voiceAvailable: action.val,
      };
    case SET_CONTACT_LIST_LOADER:
      return {
        ...state,
        contactlistLoader: action.val,
      };
    case SET_SELECTED_EXTERNAL_CHAT_TYPE:
      return {
        ...state,
        selectedExternalChatType: action.val,
      };
    case SET_SELECTED_MENU:
      return {
        ...state,
        selectedMenu: action.val,
      };
    case SET_READY_BUTTON:
      return {
        ...state,
        readyButton: action.val,
      };
    case SET_SHOWING_STATUS:
      return {
        ...state,
        showingStatus: action.val,
      };
    case SET_SHOWING_STATUS_VOICE:
      return {
        ...state,
        showingStatusVoice: action.val,
      };
    case SET_SHOWING_STATUS_CLASS:
      return {
        ...state,
        showingStatusClass: action.val,
      };
    case SET_CONTACT_LIST:
      return {
        ...state,
        contactList: action.val,
      };
    case SET_SIDEBAR_VAL:
      return {
        ...state,
        sidebarVal: action.val,
      };
    case SET_EXTERNAL_CHAT_DATA:
      return {
        ...state,
        externalChatData: action.val,
      };
    case SET_CHAT_SESSION_ID:
      return {
        ...state,
        chatSessionId: action.val,
      };
    case SET_DROPDOWN_AGENT_LIST:
      return {
        ...state,
        DropDownAgentList: action.val,
      };
    case SET_INTERNAL_CHAT_DATA:
      return {
        ...state,
        internalChatData: action.val,
      };
    case SET_CUSTOMER_TYPING_ID:
      return {
        ...state,
        customerTypingId: action.val,
      };
    case MISSED_CHATS:
      return {
        ...state,
        missedChats: action.val,
      };
    default:
      return state;
  }
};
